export const PREV_TEXT_LABEL = "Предыдущее изображение";
export const NEXT_TEXT_LABEL = "Следующее изображение";
export const MAX_PAGE_NUMBER = 5;
export const MIN_PAGE_NUMBER = 1;